import { getSchoolList, getClassList } from '@/api/endpoints';

export default {
  methods: {
    func_get_school_list() {
      getSchoolList().then(result => {
        if (!result) return;
        this.school_list = result;
      });
    },
    func_get_class_list(item) {
      this.school_value = item;
      getClassList(item.school_id).then(result => {
        if (!result) return;
        this.class_list = result;
      });
    },
  },
};
